import { CaviarOverrides } from './caviar.js';
export { CaviarColors } from './caviar.js';
import { MerchantOverrides } from './merchant.js';
import { MerchantNextOverrides } from './merchant-next.js';

var Themes = {
  Caviar: CaviarOverrides,
  Merchant: MerchantOverrides,
  MerchantNext: MerchantNextOverrides
};

export { Themes };
